export function sanitizeTenantSlugInput(value: string): string {
  let sanitizedValue = "";
  let previousWasHyphen = false;

  for (const char of value.toLowerCase()) {
    const isLowercaseLetter = char >= "a" && char <= "z";
    const isDigit = char >= "0" && char <= "9";

    if (isLowercaseLetter || isDigit) {
      sanitizedValue += char;
      previousWasHyphen = false;
      continue;
    }

    if (char === "-" && sanitizedValue !== "" && !previousWasHyphen) {
      sanitizedValue += char;
      previousWasHyphen = true;
    }
  }

  if (sanitizedValue.endsWith("-")) {
    return sanitizedValue.slice(0, -1);
  }

  return sanitizedValue;
}

export function isTenantSlugValid(value: string): boolean {
  const trimmedValue = value.trim();

  if (trimmedValue.length === 0) {
    return false;
  }

  if (trimmedValue.startsWith("-") || trimmedValue.endsWith("-")) {
    return false;
  }

  let previousWasHyphen = false;

  for (const char of trimmedValue) {
    const isLowercaseLetter = char >= "a" && char <= "z";
    const isDigit = char >= "0" && char <= "9";

    if (char === "-") {
      if (previousWasHyphen) {
        return false;
      }
      previousWasHyphen = true;
      continue;
    }

    if (!isLowercaseLetter && !isDigit) {
      return false;
    }

    previousWasHyphen = false;
  }

  return true;
}
